const VERSION = "13.2.2";
export {
  VERSION
};
